import React, { useState } from "react";
import { TextField, Box, Typography, Button, Divider } from "@mui/material";
import { Formik, Form, FieldArray } from "formik";
import * as Yup from "yup";
import Swal from "sweetalert2";
import Select from "react-select";
import { useGetLocationsQuery } from "slices/common/locationSlice";
import { useLinkLocationMutation } from "slices/beautyApp/beauticianSlice";
import { useNavigate } from "react-router-dom";

function Step3({ val }) {
  const navigate = useNavigate();
  const [locLink] = useLinkLocationMutation();
  const { data } = useGetLocationsQuery({});
  const [availableAreas, setAvailableAreas] = useState([]);

  const validationSchema = Yup.object().shape({
    city: Yup.string().required("City is required"),
    areas: Yup.array()
      .of(Yup.string().required("Area is required"))
      .min(1, "At least one area must be selected")
      .required("Areas are required"),
  });

  const initialValues = {
    city: "",
    user: val?._id,
    areas: [],
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={async (values, { setSubmitting }) => {
        console.log("values to backend", values);
        // Optional backend call
        let response = await locLink(values);
        console.log("rssss", response);
        if (response?.data?.linked) {
          navigate("/wellness/clinics");
        } else {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: response?.message,
          });
        }
      }}
    >
      {({
        values,
        errors,
        touched,
        handleChange,
        setFieldValue,
        isSubmitting,
      }) => (
        <Form>
          <Box className="container py-4">
            <Typography variant="h5" gutterBottom>
              Select City and Areas
            </Typography>

            {/* City Select */}
            <TextField
              select
              name="city"
              value={values.city}
              onChange={(e) => {
                const selectedCityId = e.target.value;
                setFieldValue("city", selectedCityId);

                const selectedCity = data?.data?.data?.find(
                  (c) => c._id === selectedCityId
                );

                setFieldValue("areas", []); // Reset areas
                setAvailableAreas(selectedCity?.areas || []);
              }}
              SelectProps={{ native: true }}
              fullWidth
              margin="normal"
              error={Boolean(errors.city && touched.city)}
              helperText={touched.city && errors.city}
            >
              <option value="">-- Select City --</option>
              {data?.data?.data?.map((city) => (
                <option key={city._id} value={city._id}>
                  {city.cityName}
                </option>
              ))}
            </TextField>

            {/* Area Select */}
            <FieldArray name="areas">
              {() => (
                <Box mt={2}>
                  <Select
                    isMulti
                    name="areas"
                    options={availableAreas.map((area) => ({
                      label: area.areaName,
                      value: area._id,
                    }))}
                    onChange={(selectedOptions) => {
                      const selectedAreaIds = selectedOptions.map(
                        (opt) => opt.value
                      );
                      setFieldValue("areas", selectedAreaIds);
                    }}
                    value={values.areas
                      .map((id) => {
                        const area = availableAreas.find((a) => a._id === id);
                        return area
                          ? { label: area.areaName, value: area._id }
                          : null;
                      })
                      .filter(Boolean)}
                    placeholder="Select Area(s)"
                    isDisabled={!values.city}
                  />

                  {touched.areas && errors.areas && (
                    <Typography variant="body2" color="error" sx={{ mt: 1 }}>
                      {typeof errors.areas === "string"
                        ? errors.areas
                        : "Invalid area(s) selected"}
                    </Typography>
                  )}
                </Box>
              )}
            </FieldArray>

            <Divider sx={{ my: 3 }} />

            {/* Submit Button */}
            <Box display="flex" justifyContent="flex-end">
              <Button type="submit" variant="contained" disabled={isSubmitting}>
                Submit
              </Button>
            </Box>
          </Box>
        </Form>
      )}
    </Formik>
  );
}

export default Step3;
